import axios from "axios";
import auth from "./auth";
import contact from "./contact";

export default {
  modules: {
    auth,
    contact
  },

  state: {
    loadingCnt: 0,
    loading: false,
    globalLoading: false,
    appTitle: null,
    appLoaded: false,
    appConfig: {},
    user: {
      loggedIn: false
    },
    userMessage: null,
    userDialog: null
  },

  mutations: {
    appTitle(state, title) {
      state.appTitle = title;
    },

    appLoaded(state) {
      state.appLoaded = true;
    },

    appConfig(state, config) {
      state.appConfig = config;
    },

    loading(state, f) {
      if (f) {
        state.loadingCnt++;
      } else {
        state.loadingCnt--;
      }

      state.loading = state.loadingCnt != 0;
    },

    globalLoading(state, f) {
      state.globalLoading = f;
    },

    authUser(state, user) {
      if (!user) {
        state.user = {
          loggedIn: false
        };
      } else {
        state.user = {
         email: user.email,
         loggedIn: true
       };
      }
    },

    appData(state, data) {
      state.appData = data;
    },

    userMessage(state, userMessage) {
      state.userMessage = userMessage;
    },

    userDialog(state, userDialog) {
      state.userDialog = userDialog;
    }
  },

  getters: {
  },

  actions: {
    appLoaded({ commit }) {
      commit("appTitle", document.title);
      commit("appLoaded", true);
    },

    appData({ commit, state }, data) {
      let appData = {};

      if (state.appData) {
        appData = Object.assign(appData, state.appData);
      }

      if (data != null) {
        appData = Object.assign(appData, data);
      }

      if (appData && "title" in appData) {
        let text = appData.title;
        if ("subtitle" in appData && appData.subtitle) {
          text += `: ${appData.subtitle}`;
        }
        if (text && text.indexOf("$") !== false) {
          Object.keys(appData).forEach((k) => {
            text = text.replace(`$${k}`, appData[k]);
          });
          text = text.replace(/\$\w+/g, "...");
        }
        document.title = `${text} – ${state.appTitle}`;
      } else {
        document.title = state.appTitle;
      }

      commit("appData", appData);
    },

    loading({ commit }, loading) {
      commit("loading", loading);
    },

    globalLoading({ commit }, globalLoading) {
      commit("globalLoading", globalLoading);
    },

    userMessage({ commit }, userMessage) {
      commit("userMessage", userMessage);
    },

    userDialog({ commit }, userDialog) {
      commit("userDialog", userDialog);
    },

    ajax(context, cfg) {
      const config = cfg;
      if (config.url && config.url.startsWith("/v1")) {
        config.url = `/wp-json/sw-immosuite${config.url}`;
        /*
        if (process.env.NODE_ENV === "production") {
          config.url = `/webapp/api${config.url}`;
        }
        */
        config.headers = {
          "X-WP-Nonce": context.state.auth.authenticationToken
          //Authorization: `Bearer ${context.state.auth.authenticationToken}`
        };
      }

      context.commit("loading", true);
      return new Promise((resolve, reject) => {
        axios(config).then((res) => {
          context.dispatch("loading", false);

          if ("method" in cfg && cfg.method.toLowerCase() === "head") {
            resolve(res);
          } else if (res.data) {
            resolve(res.data);
          } else {
            resolve(null);
          }
        }).catch((err) => {
          context.dispatch("loading", false);

          if ("hideError" in cfg && cfg.hideError) {
            reject(err);
            return;
          }

          let error = `HTTP-ERROR ${config.url}: ${err.message}`;
          if (err.response && err.response.data) {
            if ("code" in err.response.data && err.response.data.code == "internal_server_error") {
              error = "Es ist ein interner Serverfehler aufgetreten.";
            } else {
              error = err.response.data.message;
            }
          }

          context.dispatch("userMessage", {
            type: "error",
            msg: error
          });

          reject(err);
        });
      });
    }
  }
};
